<template>
  <div class="page page-shell">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="content">
      <div class="hero-card">
        <div class="hero-badge">{{ $t("setting.language") }}</div>
        <div class="hero-title">{{ $t("setting.language") }}</div>
        <div class="hero-desc">{{ $t("setting.save") }}</div>
      </div>

      <div class="list-card">
        <div
          v-for="item in languages"
          :key="item.value"
          class="lang-item"
          :class="{ active: lang === item.value }"
          @click="changeLang(item.value)"
        >
          <div class="lang-main">
            <div class="lang-name">{{ item.label }}</div>
          </div>
          <div class="lang-check" v-if="lang === item.value">✓</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "Language",
  data() {
    return {
      lang: this.$i18n.locale || "zh_tw",
      source: "",
      languages: [
        { label: "繁體中文", value: "zh_tw" },
        { label: "English", value: "en_us" },
      ],
    };
  },
  mounted() {
    this.source = this.$route.params.type;
  },
  methods: {
    back() {
      return window.history.back();
    },
    changeLang(lang) {
      if (lang === "zh_cn") {
        lang = "zh_tw";
      }
      Toast.loading({
        duration: 200,
      });
      this.lang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      if (this.source === "setting") {
        this.$router.push({ path: "/" });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.less";

.page-shell {
  min-height: 100%;
  background: linear-gradient(#1a1a1a, #000000) !important;
}

.content {
  padding: 16px;
}

.hero-card {
  padding: 20px;
  border-radius: 18px;
  border: 1px solid #444;
  background: linear-gradient(to bottom right, #33251a, #1b1435);
  margin-bottom: 16px;
}

.hero-badge {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 24px;
}

.hero-title {
  margin-top: 12px;
  color: #f4c57d;
  font-size: 36px;
  font-weight: 700;
}

.hero-desc {
  margin-top: 8px;
  color: #ddd;
  font-size: 24px;
}

.list-card {
  padding: 10px 16px;
  border-radius: 18px;
  border: 1px solid #2a2a2a;
  background: #141419;
}

.lang-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.lang-item:last-child {
  border-bottom: none;
}

.lang-item.active .lang-name {
  color: #f4c57d;
}

.lang-main {
  min-width: 0;
}

.lang-name {
  color: #fff;
  font-size: 30px;
  font-weight: 700;
}

.lang-check {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(244, 197, 125, 0.12);
  border: 1px solid rgba(244, 197, 125, 0.25);
  color: #f4c57d;
  font-size: 18px;
}
</style>
